import { PlusOutlined } from '@ant-design/icons'
import { Form, Input, Space, Tag } from 'antd'
import { useEffect, useState } from 'react'

const AddElementsInput = ({ form, inputName, inputLabel, requiredMessage, placeholder, tagColor }) => {
  const [elements, setElements] = useState([])
  const [inputValue, setInputValue] = useState('') // input state

  // manage changes in input
  const handleInputChange = (e) => {
    setInputValue(e.target.value)
  }

  useEffect(() => {
    form.setFieldsValue({ [inputName]: elements })
  }, [elements, form, inputName])

  const handleAddElement = () => {
    if (inputValue.trim() && !elements.includes(inputValue)) {
      setElements([...elements, inputValue.trim()]) // add only the last string
      setInputValue('') // clean input after adding
    }
  }

  const handleRemoveElement = (nameToRemove) => {
    setElements(elements.filter(name => name !== nameToRemove)) // update state
  }

  return (
    <Form.Item
      name={inputName}
      label={inputLabel}
      rules={[{ required: true, message: requiredMessage }]}
      style={{ display: 'inline-block', width: '48%' }}
    >
      <Input
        value={inputValue}
        onChange={handleInputChange}
        placeholder={placeholder}
        onPressEnter={handleAddElement}
        addonAfter={
          <div style={{
            backgroundColor: '#17bebb',
            padding: '9px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
            height: '100%',
            margin: '-11px'
          }}
          >
            <PlusOutlined style={{ cursor: 'pointer' }} onClick={handleAddElement} />
          </div>
      }
      />
      <Space style={{ marginTop: 8, display: 'flex', flexWrap: 'wrap' }}>
        {elements.map(name => (
          <Tag
            key={name}
            closable
            onClose={() => handleRemoveElement(name)}
            style={{ color: tagColor, borderColor: tagColor }}
          >
            {name}
          </Tag>
        ))}
      </Space>
    </Form.Item>
  )
}

export default AddElementsInput
